uniform sampler2D uAtlas;
uniform float uLogDepthBufFC;
uniform vec3  uSkyTop;        // hemisphere-averaged HDR irradiance, upper half (linear)
uniform vec3  uSkyBottom;     // hemisphere-averaged HDR irradiance, lower half (linear)
uniform float uEffectBrightness; // per-scenario dim for the env-lit term (emissive untouched)

in vec2  vUv;
in float vAlpha;
in float vEmissive;
in vec3  vColor;
in float vFragDepth;

out vec4 fragColor;

// Bias toward sky-top — billboards have no real normal, but volumetric puffs
// catch more light from above than below.
const float SKY_UP_WEIGHT = 0.7;

void main() {
  vec4 tex = texture(uAtlas, vUv);
  float a  = tex.r * vAlpha;
  if (a < 0.001) discard;

  vec3 color = tex.rgb * vColor;

  // Environment lighting for non-emissive particles (smoke, dust).
  // Reinhard soft-ceiling on the lighting term keeps particles from going
  // pure white under bright HDRs and prevents them from triggering the bloom
  // threshold by themselves — the relative tint of the sky is preserved.
  float envBlend = 1.0 - clamp(vEmissive, 0.0, 1.0);
  if (envBlend > 0.0) {
    vec3 envLight = mix(uSkyBottom, uSkyTop, SKY_UP_WEIGHT);
    envLight = envLight / (vec3(1.0) + envLight);
    envLight *= 2.0 * uEffectBrightness; // restore mid-grey lit smoke to ~1.0, then per-scenario dim
    color *= mix(vec3(1.0), envLight, envBlend);
  }

  // Emissive boost — drives bloom pass pickup
  color *= (1.0 + vEmissive);

  // Premultiply — renderer uses premultipliedAlpha (default)
  fragColor = vec4(color * a, a);

  // Logarithmic depth buffer — must write gl_FragDepth for correct depth test
  gl_FragDepth = log2(vFragDepth) * uLogDepthBufFC * 0.5;
}
